import { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';

import { PrimaryButton, SecondaryButton } from 'components/Button';
import { HotelSearchQuery } from 'generated/graphql';
import { addToShortList, removeFromShortList } from 'store/groupDetailsSlice';
import { useAppSelector } from 'store/store';

type HotelResult = HotelSearchQuery['hotelSearch']['results'][number]['hotel'];

export const AddOrRemoveFromShortListButton = ({
  hotel,
}: {
  hotel: HotelResult;
}) => {
  const dispatch = useDispatch();
  const hotelInList = useAppSelector((state) =>
    state.groupDetails.shortList.find(
      ({ amadeusHotelId }) => amadeusHotelId === hotel.amadeusHotelId,
    ),
  );

  const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!hotelInList) {
      dispatch(addToShortList(hotel));
    } else {
      dispatch(removeFromShortList(hotel.amadeusHotelId));
    }
  };

  if (!hotelInList) {
    return (
      <PrimaryButton onClick={handleOnClick}>Add to Shortlist</PrimaryButton>
    );
  } else {
    return (
      <SecondaryButton onClick={handleOnClick}>
        Remove from Shortlist
      </SecondaryButton>
    );
  }
};
